<div [class]="style" (click)="toogle()" [title]="helpText" class="map-style mat-elevation-z16">
</div>
